import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import nl from 'date-fns/locale/nl';
import "react-datepicker/dist/react-datepicker.css";
import { getDepartments } from '../services';
registerLocale('nl', nl)

const DashboardFilter = (props) => {
  setDefaultLocale('nl');
  const { startDate, endDate, filter, formStep, pdfButton, locationId } = props;

  const [department, setDepartment] = useState();
  const [departmentArray, setDepartmentArray] = useState();

  let kgButtonClass = '';
  let euroButtonClass = '';

  useEffect(()=>{
      getDepartments(locationId).then(list => {
        setDepartmentArray(list)
      })
    setDepartment(0)
  }, [locationId])

  filter === 1
    ? euroButtonClass = 'dashboard__filter__button__active'
    : kgButtonClass = 'dashboard__filter__button__active'

  return (
    <div className="dashboard__filters">
      {formStep != 5 &&
        <button
          onClick={() => props.setFilter(1)}
          className={"dashboard__filter__button "+euroButtonClass}
        >
          Euro
        </button>
      }
      {formStep != 5 &&
        <button
          onClick={() => props.setFilter(0)}
          className={"dashboard__filter__button "+kgButtonClass}
        >
          Kilo
        </button>
      }

      <DatePicker
        className="dashboard__filter__date"
        onChange={(date) => {
          props.setStartDate(date);
        }}
        value={new Date(startDate).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' })}
      />
      <DatePicker
        className="dashboard__filter__date"
        onChange={(date) => {
          props.setEndDate(date);
        }}
        value={new Date(endDate).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' })}
      />

      {formStep == 3 &&
        <select
          id="selectbox__location"
          className="dashboard__filter__date"
          value={props.departmentId}
          onChange={(e) => props.setDepartmentId(e.target.value)}
        >
            <option value="0">Selecteer een afdeling</option>
            {departmentArray}
        </select>
      }

      {pdfButton}
    </div>
  );
};

export default DashboardFilter;
